import React from 'react'
import { GridFluid } from '@styles/global/cssGrid'
import { renderSvg } from '@utils/genUtils'
import { svgs } from '@svg'
import { Width } from '@utils/window'
import VerticalCategory from '@components/dividers/verticalCategory'
import ImgSmall from '@components/imageModules/v2/imgSmall'
import { IGatsbyChildImageSharp, IGatsbyImageDataObject } from '@et/types/Gatsby'
import {
  BioWrapper,
  InstructorContainer,
  InstructorImageWrapper,
  InstructorInkStreak, Profile,
  SpacerBlock,
  SpacerBlockTop,
} from '@styles/modules/instructorLayout'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import GatsbyImgSmall from '@components/imageModules/v3/gatsbyImgSmall'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GATSBYIMGLOADING } from '@et/types/Enums'

interface IProps {
  heyImg?: IGatsbyImageDataObject,
  altBg?: string,
  profileImg: IGatsbyImageDataObject
  streakImg: IGatsbyImageDataObject
}

function InstructorLayoutBV4 (
  {
    streakImg,
    heyImg,
    profileImg,
    altBg,
  }: IProps) {
  return (
    <InstructorContainer altBg={altBg}>
      <GridFluid>
        <VerticalCategory
          text={`your instructor`}/>
        <SpacerBlockTop/>
        <InstructorImageWrapperWithBorder>
          <ProfileWrapper>
            <Profile>
              <GatsbyImage
                alt={'Teela Cunningham Hand Letterer, Designer, and Online course Instructor'}
                image={profileImg.gatsbyImageData}
                loading={GATSBYIMGLOADING.LAZY}/>
            </Profile>
            <ProfileBorderImg>
              <GatsbyImage
                className={'profile-border'}
                alt={`Every-Tuesday Pink Paint Streak Texture`}
                image={streakImg.gatsbyImageData}
                loading={GATSBYIMGLOADING.LAZY}/>
            </ProfileBorderImg>
          </ProfileWrapper>
        </InstructorImageWrapperWithBorder>
        <BioWrapperOrange>
          {heyImg
            ? <GatsbyImage
              className={'profile-border'}
              alt={`Hey, I\'m Teela`}
              image={heyImg.gatsbyImageData}
              loading={GATSBYIMGLOADING.LAZY}/>
            : renderSvg(svgs.Hey)}
          <h2>
            I help graphic designers and hand letterers build upon their skillsets to open new creative and financial
            opportunities.
          </h2>
          <p>
            If you’re familiar with Every-Tuesday, then you know my love for lettering + design runs deep. In fact, in
            the last 4 years, I’ve taught over 50,000 students and my design + lettering videos on YouTube have
            accumulated over 10 million views.
          </p>
          <p>
            I love sharing what I’ve learned over my career and the creative tips that will have your artwork leveling
            up in no time.
          </p>
        </BioWrapperOrange>
        <SpacerBlock/>
      </GridFluid>
    </InstructorContainer>
  )
}

const BioWrapperOrange = styled(BioWrapper)`
  svg{
    path{
      fill: #f0a43b;
    }
  }
`
const ProfileWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  
  @media ${device.tablet} {
    max-width: 270px;    
  }
  	
`
const InstructorImageWrapperWithBorder = styled(InstructorImageWrapper)`
  padding: 160px 0 20px;
  
  @media ${device.laptop} {
    padding: 0;  
  }
  
`
const ProfileBorderImg = styled.div`
  position: absolute;
  top: -135px;
  left: -44px;
  width: 380px;
  
  @media ${device.tablet} {
    top: -149px;
    left: -89px;
    width: 400px;    
  }  
  
  @media ${device.laptop} {
    left: -89px;
  }
  	
`
export default InstructorLayoutBV4
